import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack, Box } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const AppAuthAccessFailureWindowField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!(errors.accessFailureWindow && touched.accessFailureWindow)
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Access Failure Window
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Time window for counting access failures (in minutes).
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NumberField}
                            name="accessFailureWindow"
                            id="accessFailureWindow"
                            placeholder="Enter access failure window"
                            min={0}
                            width="100%"
                            customWidth="100%"
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Set the time window in minutes for counting access failures"
                        ariaLabel="access-failure-window-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AppAuthAccessFailureWindowField;
